
import FpgNav from './Nav.vue';

export default {
    props: ['element', 'item', 'buttonBlock'],
    components: {FpgNav},
    emits: ['applyFilter'],
    methods: {
        onApplyFilterByTag(tag) {
            this.$emit('applyFilter', this.element.identity, tag.valueId);
        }
    },
}
